module.exports = __webpack_public_path__ + "img/rank_3.b82f6376.png";